import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import useGetVAT from '../../common/category/useVAT'
import { Element } from '../../common/html/element'
import { Loading } from '../../common/loading'
import { selectUserType } from '../../layout/store/slice'
import { TYPES_DISCOUNT } from '../../utils/common'
import { TradeDiscountPopup } from '../common/poup/TradeDiscountPopup'
import { STEP } from '../constant'
import classes from '../index.module.scss'
import {
  changeParamsDiscount,
  selectBusinessCreditReportId,
  selectCheckIds,
  selectFactSheetId,
  selectFragmentCart,
  selectLoading,
} from '../store/slice'
import { getCartItems, getDiscount } from '../store/thunk'
import BusinessCreditReport from './BusinessCreditReport'
import CheckAll from './CheckAll'
import FactSheet from './FactSheet'
import { NoCart } from './NoCart'
import { SummaryPrice } from './SummaryPrice'

const Cart = ({ setStep }) => {
  const dispatch = useDispatch()

  const { loading: loadingVAT, vatPercentage } = useGetVAT()

  const locale = useSelector((state) => state.i18n.locale)
  const userType = useSelector(selectUserType)
  const fragment = useSelector(selectFragmentCart)
  const loadingCart = useSelector(selectLoading('getCartItems'))
  const loadingDiscount = useSelector(selectLoading('getDiscount'))
  const factSheetId = useSelector(selectFactSheetId)
  const businessCreditReportId = useSelector(selectBusinessCreditReportId)
  const check = useSelector(selectCheckIds)

  const [isShowDiscount, setShowDiscount] = useState(false)
  const [isFirst, setFirst] = useState(!check.length ? false : true)

  const loading = loadingCart || loadingDiscount || loadingVAT

  const nextStep = () => {
    setStep(STEP.ORDER_INFORMATION)
  }

  const openPopupTradeDiscount = () => {
    setShowDiscount(true)
  }

  const closePopupTradeDiscount = () => {
    setShowDiscount(false)
  }

  const scrollToElement = () => {
    const scrollDiv = document.querySelector(
      '#SCROLL_LAYOUT_ELEMENT_ID .scrollbars div:first-child',
    )
    const scrollElement = document.getElementById(check[0])

    if (scrollDiv && scrollElement) {
      scrollDiv.scrollTo({
        top: scrollElement.offsetTop,
        behavior: 'smooth',
      })
    }
  }

  useEffect(() => {
    dispatch(changeParamsDiscount([TYPES_DISCOUNT.Order]))
    dispatch(getDiscount())
    dispatch(getCartItems({ userType: userType.userTypeId }))
  }, [locale, fragment])

  useEffect(() => {
    if (
      !!check.length &&
      isFirst &&
      !![...factSheetId, ...businessCreditReportId].length
    ) {
      scrollToElement()
      setFirst(false)
    }
  }, [check, [...factSheetId, ...businessCreditReportId].length])

  return (
    <>
      {loading ? (
        <Loading />
      ) : ![...factSheetId, ...businessCreditReportId].length ? (
        <>
          <NoCart />
        </>
      ) : (
        <>
          <Element
            style={{ backgroundColor: '#FFFFFF' }}
            className={classes.cartContainer}
          >
            <Element
              className={classes.header}
              style={{ backgroundColor: '#0553A5', color: '#FFFFFF' }}
            >
              <div className={classes.column1} />
              <Element
                style={{ fontSize: 14 }}
                className={`fw600 ${classes.column2}`}
              >
                <Translate value="cartAndOrders.cart.product" />
              </Element>
              <Element
                style={{ fontSize: 14 }}
                className={`fw600 textCenter ${classes.column3}`}
              >
                <Translate value="cartAndOrders.cart.totalPrice" />
              </Element>
            </Element>
            <FactSheet />
            <BusinessCreditReport />
            <Element
              className={classes.resultContainer}
              style={{
                backgroundColor: '#FFFFFF',
                borderTop: '1px solid #D5D5D5',
              }}
            >
              <Element
                className={classes.content}
                style={{ backgroundColor: '#EDF5FE' }}
              >
                <CheckAll />
                <SummaryPrice
                  nextStep={nextStep}
                  openPopupTradeDiscount={openPopupTradeDiscount}
                  vatPercentage={vatPercentage}
                  userType={userType}
                />
              </Element>
            </Element>
          </Element>
          <TradeDiscountPopup
            isShow={isShowDiscount}
            onClose={closePopupTradeDiscount}
          />
        </>
      )}
    </>
  )
}

export default Cart
